import React from 'react';

const ActionItemsPage = () => {
  return (
    <div>
      <h1>Action Items</h1>
    </div>
  );
};

export default ActionItemsPage;
